import { Pipeline } from "../../../types/domain";
import { DataTable, TableColumn, LinkCell, TextCell, CountCell, ActionCell } from "@/components/common/Table";
import { useNavigate } from "react-router";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { DeletePipelineDialog } from "./DeletePipelineDialog";
import { useLayout } from "@/contexts/LayoutContext";

type PipelineListProps = {
  pipelines: Pipeline[];
  onPipelineDeleted?: () => Promise<void>;
  isLoading?: boolean;
}

export const PipelineList = ({ pipelines, onPipelineDeleted, isLoading = false }: PipelineListProps) => {
  const navigate = useNavigate();
  const { data: layoutData } = useLayout();
  const erpConfigured = layoutData.erpConfigured;

  const columns: TableColumn<Pipeline>[] = [
    {
      key: "name",
      header: Translation.PipelineMaintenance.lblName,
      render: (pipeline: Pipeline) => (
        <LinkCell
          onClick={() => navigate(`/PipelineMaintenance/EditPipeline/${pipeline.id}`)}
          text={pipeline.name || Translation.PipelineMaintenance.btnUnamed}
          title="Pipeline Details"
        />
      )
    },
    {
      key: "description",
      header: Translation.PipelineMaintenance.description,
      skeleton: { variant: 'long' },
      render: (pipeline: Pipeline) => (
        <TextCell value={pipeline.description} />
      )
    },
    {
      key: "subscribedAnalysis",
      header: Translation.PipelineMaintenance.subscribedAnalysis,
      skeleton: { variant: 'short' },
      render: (pipeline: Pipeline) => (
        <CountCell array={pipeline.analysisDisplayOptions} />
      )
    },
    {
      key: "quotationEnabled",
      header: "Quotations Enabled",
      skeleton: { variant: 'short' },
      render: (pipeline: Pipeline) => (
          pipeline.quotationEnabled 
            ? ("Yes")
            : ("No")
      ),
      hidden: !erpConfigured
    },
    {
      key: "actions",
      header: "",
      isAction: true,
      skeleton: { variant: 'short' },
      render: (pipeline: Pipeline) => (
        <div className="flex items-center gap-1">
          <ActionCell
            actions={[
              {
                icon: faPencil,
                title: 'Edit',
                onClick: () => navigate(`/PipelineMaintenance/EditPipeline/${pipeline.id}`)
              }
            ]}
          />
          {onPipelineDeleted && (
            <DeletePipelineDialog 
              pipeline={pipeline} 
              callBack={onPipelineDeleted} 
            />
          )}
        </div>
      )
    }
  ];

  return (
    <DataTable<Pipeline>
      columns={columns}
      data={pipelines}
      isLoading={isLoading}
      skeletonRows={10}
    />
  );
};

